import type { Tab } from "@/types/dynamic-detail";

export type PlaceableTab = Tab & { panel_for?: string | null };

export function navigationTabs(tabs: PlaceableTab[]): PlaceableTab[] {
    return tabs.filter(tab => !tab.panel_for);
}

export function sidePanelTabs(tabs: PlaceableTab[], currentTabPath: string | undefined): PlaceableTab[] {
    return tabs.filter(tab => tab.panel_for === currentTabPath);
}
